import { render, staticRenderFns } from "./expandItem.vue?vue&type=template&id=2e38f8eb&scoped=true"
import script from "./expandItem.vue?vue&type=script&lang=js"
export * from "./expandItem.vue?vue&type=script&lang=js"
import style0 from "./expandItem.vue?vue&type=style&index=0&id=2e38f8eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e38f8eb",
  null
  
)

export default component.exports